module.exports = __webpack_public_path__ + "media/images/procedimiento-consulta-color-a0aac9e1981476d302f5bc6233dc6c15.png";